import AllInclusive from '@mui/icons-material/AllInclusive'
import { useMemo } from 'react'
import {
  TimerClockDataContainer,
  TimerDigitsContainer,
} from 'src/consumer/components/TimerComponent/TimerComponent/styledComponents'
import { PRACTICE_TIMER_TYPES } from 'src/consumer/constants'
import TimeSelectionInput from './TimeSelectionInput'

export default function SelectedTime({ timeInMilliseconds, timerType, setTimerSettings, ...rest }) {
  const timerDataToShow = useMemo(() => {
    switch (timerType) {
      case PRACTICE_TIMER_TYPES.unlimited:
        return <AllInclusive sx={{ fontSize: '130px' }} />
      default:
        return (
          <div style={{ height: '130px', display: 'flex', alignItems: 'center' }}>
            <TimeSelectionInput
              timeInMilliseconds={timeInMilliseconds}
              setTimerSettings={setTimerSettings}
            />
          </div>
        )
    }
  }, [timerType, timeInMilliseconds, setTimerSettings])

  return (
    <TimerClockDataContainer>
      <TimerDigitsContainer style={{ lineHeight: '65px' }}>{timerDataToShow}</TimerDigitsContainer>
    </TimerClockDataContainer>
  )
}
